
export default {
  name: "ImageOverlay",

  props: {
    block: {
      type: Object,
      required: true
    },
    lazy: {
      type: Boolean,
      default: true
    }
  }
}
